/**
 * Created by pavelkozhin on 02/08/16.
 */

define([
    'jQuery',
    'underscore'
], function($, _) {

    /**
     * Component handles seasons data fallback when MightyC data is not there due to issue with season code.
     *
     * @param requestHandler
     * @param route
     * @param trackedRoutes
     * @constructor
     */
    var SeasonFallback = function(requestHandler, route, trackedRoutes) {
        if (!requestHandler) {
            throw new Error('Parameter \'requestHandler\' is mandatory');
        }
        this._requestHandler = requestHandler;

        if (!_.isString(route)) {
            throw new Error('Parameter \'route\' should be string');
        }
        this._route = route;

        if (!_.isArray(trackedRoutes)) {
            throw new Error('Parameter \'trackedRoutes\' should be array');
        }
        this._trackedRoutes = trackedRoutes;

        this._defaults = {
            itemSelector: '[data-fcse-role="accordion"] [data-fcse-role="offer-item"][data-season-fallback]',
            itemSelectorTpl: '[data-fcse-role="accordion"] [data-fcse-role="offer-item"][data-season-fallback="@"]',
            nameContainerSelector: '[data-fcse-role="name-container"]',
            imageContainerSelector: '[data-fcse-role="image-container"]',
            categoryContainerSelector: '[data-fcse-role="category-container"]',
            locationContainerSelector: '[data-fcse-role="location-container"]'
        };

        this._init();
    };

    SeasonFallback.prototype = {
        /**
         * Initializes component
         * @private
         */
        _init: function() {
            this._requestHandler.on('start', $.proxy(this._onRequestStart, this));
            this._requestHandler.on('success', $.proxy(this._onRequestSuccess, this));

            this._requestFallback();
        },

        /**
         * Aborts fallback request if any tracked request is started
         * @param {Object} requestData
         * @private
         */
        _onRequestStart: function(requestData) {
            if (_.indexOf(this._trackedRoutes, requestData.route) !== -1) {
                this._requestHandler.cancel(this._route);
            }
        },

        /**
         * Starts fallback request on tracked route success or updates elements
         * @param {Object} content
         * @param {Object} requestData
         * @private
         */
        _onRequestSuccess: function(content, requestData) {
            var self = this;
            if (_.indexOf(this._trackedRoutes, requestData.route) !== -1) {
                this._requestHandler.cancel(this._route);

                setTimeout(function() {self._requestFallback();}, 0);
            } else if (requestData.route === this._route && content.meta && content.meta.items) {

                _.each(content.meta.items, function(value, key) {
                    var itemElement = $(self._defaults.itemSelectorTpl.replace('@', key));
                    if (itemElement.length) {
                        self._updateItem(itemElement, value);
                    }
                });
            }
        },

        /**
         * Does season fallback request if necessary
         * @private
         */
        _requestFallback: function() {
            var fallbackIds;
            var fallbackItems = $(this._defaults.itemSelector);

            if (!fallbackItems.length) {
                return;
            }
            fallbackIds = [];

            fallbackItems.each(function() {
                var thisElement = $(this);
                fallbackIds.push(thisElement.attr('data-season-fallback'));
            });

            if (fallbackIds.length) {
                this._requestHandler.send(this._route, {}, {seasonsAndCodes: fallbackIds.join(',')});
            }
        },

        /**
         * Updates item content with fallback season data
         * @param element
         * @param {Object} fallbackData
         * @private
         */
        _updateItem: function(element, fallbackData) {
            try {
                if (fallbackData.name) {
                    $(this._defaults.nameContainerSelector, element).text(fallbackData.name);
                }
                if (fallbackData.location) {
                    $(this._defaults.locationContainerSelector, element).text(fallbackData.location);
                }
                if (fallbackData.imageUrl) {
                    $(this._defaults.imageContainerSelector, element).find('img').attr('src', fallbackData.imageUrl);
                }
                if (fallbackData.category) {
                    $(this._defaults.categoryContainerSelector, element).html(decodeURIComponent(fallbackData.categoryView));
                }
            } catch (e) {
            }
            element.removeAttr('data-season-fallback');
        }
    };

    return SeasonFallback;
});


// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/components/seasonfallback/seasonFallback.js